import styled from 'styled-components/macro';
import { NavLink } from 'react-router-dom';
import { deviceMax, deviceMin } from 'utils/styles/breakpoints';
import { FONTS, FONT_FAMILY } from 'utils/styles/fonts';
import { COLORS } from 'utils/styles/colors';
import { FLEX_CONTAINER } from 'utils/styles/flex';

export const ContentContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  ${FLEX_CONTAINER.FlexSpaceBetweenRow}

  @media ${deviceMin.mobileS} {
    padding: 0 40px;
  };

  @media ${deviceMin.tablet} {
    padding: 0 72px;
  };

  @media ${deviceMin.laptopL} {
    padding: 0 150px;
  }

  @media ${deviceMin.desktop} {
    padding: 0 162px;
  }
`;

export const NavigationContainer = styled.div`
  ${FLEX_CONTAINER.FlexRow}
`;

export const NavigationWrap = styled.nav`
  ${FLEX_CONTAINER.FlexEndRow}
  margin-left: 80px;
  position: relative;

  @media ${deviceMin.mobileS} {
    display: none;
  }

  @media ${deviceMin.laptopL} {
    ${FLEX_CONTAINER.FlexRow}    
  }
`;

export const MainContainer = styled.div`
  ${FLEX_CONTAINER.FlexSpaceBetweenRow}    
  margin: 0 auto;
  left: 0;
  right: 0;
  width: 100%;
  max-width: 1920px;
  height: 65px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  background: ${COLORS.ultralightGray};
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.25);
  transition: 0.5s;

  @media ${deviceMax.tablet} {
    min-height: 74px;
  }

  @media ${deviceMax.mobileL} {
    min-height: 50px;
  }
`;

export const ProfileInfoBlock = styled.div``;

export const StyledNavLink = styled(NavLink)`
  ${FONTS.font16}
  color: ${COLORS.mainColor};
  padding: 10px 0;
  cursor: pointer;
  position: relative;

  &:active {
    ${FONTS.font16}
    color: ${COLORS.mainColor};
    ${FONT_FAMILY.FontBold}
  }

  @media ${deviceMin.laptopL} {
    margin-right: 32px;
  }

  .activeLink {
    ${FONTS.font16}
    color: ${COLORS.mainColor};
    ${FONT_FAMILY.FontBold}
  }

  .MuiBadge-root {
    .MuiBadge-badge {
      top: -17px;
      right: -10px;
      width: 10px;
      min-width: 10px;
      ${FONTS.font12}

    }
  }

  &.active {
    color: ${COLORS.darkGrey};
  }

  &:hover {
    transition: all 0.3s ease-in-out;
  }
  &::after {
    content: '';
    display: block;
    width: 0;
    position: absolute;
    bottom: 0;
    height: 2px;
    background: ${COLORS.blue};
    transition: cubic-bezier(0.77, 0, 0.18, 1) 0.3s;
  }

  &:hover::after {
    width: 100%;
    bottom: 0;
  }

  & .MuiBadge-anchorOriginTopRightRectangle {
    background: ${COLORS.red};
    right: -30px;
    top: -30px;
    transform: scale(1.5);
    color: ${COLORS.white};
    pointer-events: none;
  }

  @media ${deviceMax.laptopM} {
    ${FONTS.font14};
    margin: 0 37px;
    
    &:last-child {
      margin-right: 64px;
    }
  }

  @media ${deviceMax.tablet} {
    ${FONTS.font28};
  }

  @media ${deviceMax.mobileL} {
    ${FONTS.font14};
    padding: 18px 8px;
  }
`;
